import * as React from 'react';

const Header = ({ firstpage = true }) => (
    <div>

    </div>
);
export default Header;